import { render, staticRenderFns } from "./OrderAminView.vue?vue&type=template&id=15f15144&"
import script from "./OrderAminView.vue?vue&type=script&lang=ts&"
export * from "./OrderAminView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports